import styled from 'styled-components';

export const MarkdownContainer = styled.div.attrs({
  className: 'my-4'
})`
  font-family: MuseoSans-100;
  font-size: 14px;

  a:hover {
    color: #0081c6;
  }
`;
